module.exports = __webpack_public_path__ + "img/video-title.876b6958.png";